<template>
  <app-table v-bind="$attrs" class="w-full">
    <template v-slot:table-body>
      <tr
        v-for="(item, index) in filteredItems"
        :key="index"
        class="border border-collapse border-dashed border-red border-t-0 border-l-0 border-r-0 h-12 hover:bg-red-lightest"
        @click="openActiveDialog(item)"
      >
        <td width="36px">
          <img
            class="mx-2 my-3"
            :src="getTypeIcon(item.documentType)"
            style="width:20px;height:20px;"
          />
        </td>
        <td width="108px">
          <span class="text-lg mr-3">{{
            $filters.dateFormat(item.updatedAt)
          }}</span>
        </td>
        <td width="520px">
          <div class="flex flex-row items-center">
            <user-circle-icn
              width="20"
              height="20"
              class="red-icon-user"
            ></user-circle-icn>
            <div>
              <span
                class="ml-1"
                :class="item.user.id === currentUser.id ? 'font-bold ' : ''"
              >
                {{ item.user.uname }}
              </span>
              <span class="ml-1 text-lg">{{ item.firstText }}</span>
            </div>
          </div>
        </td>
        <td>
          <div class="flex flex-row items-center">
            <img
              class="mr-1"
              :src="getIcon(item.updateType)"
              style="width:20px;height:20px;"
            />
            <span class="text-lg">{{ item.secondText }}</span>
          </div>
        </td>
      </tr>
    </template>
  </app-table>
  <budget-dialog v-if="isOpen && type === 'budgets'"></budget-dialog>
  <receipt-dialog v-if="isOpen && type === 'receipt'"></receipt-dialog>
  <activities-dialog
    v-if="isOpen && type === 'politicalAction'"
  ></activities-dialog>
</template>

<script>
import { ref, onMounted, watch, computed } from 'vue'
import AppTable from '@/components/ui/AppTable'
import UserCircleIcn from '@/assets/icons/user-circle.svg?inline'
import BudgetDialog from '@/components/layout/budgets/BudgetDialog.vue'
import ReceiptDialog from '@/components/layout/receiptsOsaka/ReceiptDialog.vue'
import ActivitiesDialog from '@/components/layout/activities/ActivitiesDialog'
import { useCurrentUser } from '@/services/useCurrentUser'
import { useStatus } from '@/services/notification/useStatus'
import { useNotifications } from '@/services/notification/useNotifications'
import { useBudgetDialog } from '@/services/useBudgetDialog'
import { useReceiptDialog } from '@/services/receiptsOsaka/useReceiptDialog'
import { usePoliticalActionDialog } from '@/services/politicalAction/usePoliticalActionDialog'
import { useDialog } from '@/services/useDialog'
import { useYearSelector } from '@/services/useYearSelector'
import { useKeywordSearch } from '@/services/useKeywordSearch'

export default {
  name: 'NotificationsTable_OSAKA',

  components: {
    AppTable,
    UserCircleIcn,
    BudgetDialog,
    ReceiptDialog,
    ActivitiesDialog,
  },

  setup() {
    const count = ref(5)
    const { keyword } = useKeywordSearch()
    const { currentUser } = useCurrentUser()
    const { notificationTop, getNotifications } = useNotifications()
    const { getTypeIcon, getIcon } = useStatus()
    const { openBudgetPreviewRegistered } = useBudgetDialog()
    const { openReceiptDialog } = useReceiptDialog()
    const { changeDocument } = usePoliticalActionDialog()
    const { currentYear, resetYear } = useYearSelector()
    const { isOpen, type } = useDialog()

    const openActiveDialog = item => {
      if (item.documentType === 1) {
        openBudgetPreviewRegistered(item.documentId)
      }
      if (item.documentType === 2) {
        openReceiptDialog(item.documentId)
      }
      if (
        item.documentType === 3 ||
        item.documentType === 4 ||
        item.documentType === 5
      ) {
        changeDocument(item.documentType, item.documentId)
      }
    }
    const filteredItems = computed(() => {
      return filterByKeyword(notificationTop.value)
    })

    const filterByKeyword = items => {
      return items.filter(function(item) {
        return (
          (item.user['uname'] + item['firstText'] &&
            (item.user['uname'] + item['firstText']).includes(keyword.value)) ||
          (item['secondText'] && item['secondText'].includes(keyword.value))
        )
      })
    }

    onMounted(async () => {
      resetYear()
      await getNotifications(currentYear.value)
    })

    watch(currentYear, async currentYear => {
      await getNotifications(currentYear)
    })

    return {
      count,
      notificationTop,
      currentUser,
      getTypeIcon,
      getIcon,
      isOpen,
      type,
      openActiveDialog,
      filteredItems,
      keyword,
    }
  },
}
</script>
